import { api } from '../api';

export const confirmPassword = async (password: string): Promise<boolean> => {
  const {
    data: { didMatch },
  } = await api.post('/users/password/confirm', { password });

  return !!didMatch;
};
